module.exports = __webpack_public_path__ + "img/service_point.45bb1aa.png";